const env = window.location.origin.split(".")[1] || "local";
const localEndpoint = "http://localhost:3000";
// TODO: 後で消す
const localApiEndpoint = "http://localhost:3001";
const getApplicationName = (env: string) => {
  switch (env) {
    case "devu":
      return "609213";
    case "na":
      return "327052";
    default:
      return "";
  }
};
const getClientId = (env: string) => {
  switch (env) {
    case "devu":
      return "70ceWCOSL9bUCaSQcWVEUWBVdhJ8HpAD";
    case "na":
      return "70wZAcIWR8Wy00mJ8U0w7MRexrRht2iJ";
    default:
      return "";
  }
};
const getClientName = (env: string) => {
  switch (env) {
    case "devu":
      return "115481787014021873588";
    case "na":
      return "107510525038696941027";
    default:
      return "";
  }
};

const getScheduleAppInitialDataId = (env: string) => {
  switch (env) {
    case "devu":
      return 1636232;
    case "na":
      return 1542068;
    default:
      return -1;
  }
};

export const APP_ENDPOINT =
  env !== "local"
    ? `https://g-suite.${env}.smart-integration.ricoh.com`
    : localEndpoint;

// TODO: localEndpointへ
export const API_ENDPOINT =
  env !== "local"
    ? `https://g-suite-api.${env}.smart-integration.ricoh.com`
    : localApiEndpoint;

export const WORK_PLACE_ENDPOINT =
  env !== "local" ? `https://${env}.accounts.ricoh.com` : localEndpoint;

// TODO: localEndpointへ
export const SI_API_ENDPOINT =
  env !== "local"
    ? `https://api.${env}.smart-integration.ricoh.com`
    : localApiEndpoint;

export const SI_SITE_ENDPOINT =
  env !== "local"
    ? `https://www.${env}.smart-integration.ricoh.com`
    : localEndpoint;

export const APPLICATION_NAME = getApplicationName(env);
export const CLIENT_ID = getClientId(env);
export const CLIENT_NAME = getClientName(env);
export const SCHEDULE_APP_INITIAL_DATA_ID = getScheduleAppInitialDataId(env);

export const DIRECTORY_SCOPES: string[] = [
  "https://www.googleapis.com/auth/admin.directory.group.member.readonly",
  "https://www.googleapis.com/auth/admin.directory.group.readonly",
  "https://www.googleapis.com/auth/admin.directory.user.readonly",
];

export const FLOW_NAME: string = "main";

export const SCHEDULE_TIME_FLOW_NAME: string = "issueScheduleTime";

export const KEY_G_SUITE_ACCESS_TOKEN: string = "gSuiteAccessToken";

// https://github.com/ricoh/chef-repo2/blob/aws_pf_master/site-cookbooks/si_site/templates/default/gsuite.properties.erb#L3
export const VALID_SERVICE_CLASS: string[] = [
  "SI_sdca-demo_gsuite",
  "SI_ricoh-sdca-p_20180712175704",
  "SI_ricoh-sdca-p_20190520173345",
  "SI_ricoh-sdca-p_20190508211317",
  "SI_ricoh-sdca-p_20180712174032",
  "SI_ricoh-sdca-p_20190430210020",
];
